module.exports = __webpack_public_path__ + "81340702d4f7df9335c1598d334e0688.png";